import { render, staticRenderFns } from "./TeleMarketUserGroupEditModal.vue?vue&type=template&id=53de2c67&scoped=true"
import script from "./TeleMarketUserGroupEditModal.vue?vue&type=script&lang=js"
export * from "./TeleMarketUserGroupEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53de2c67",
  null
  
)

export default component.exports